import { Button, Form, Stack } from "react-bootstrap"
import { ReactComponent as ReloadIcon } from "../svgs/refresh.svg"


var searchTimer :NodeJS.Timeout;

type SearchProps = {
    clear? : ()=>void
    search? : (query:string)=>void
    placeholder? : string
    onReload? : ()=>void | null
}

const Searchbar : React.FC<SearchProps> = ({
    clear=()=>{},
    search=(query:string)=>{},
    placeholder="Search user by name, client id, mobile, email etc",
    onReload=null,
}) => {
    
    const onChanged = (e:any) => {
        if (e.target.value.length === 1) return

        clearTimeout(searchTimer)
        searchTimer = setTimeout(() => {
            clear()
            search(e.target.value)
            //console.log("query", e.target.value);
        }, 500)
    }
    //console.log(query)
    return (
        <Stack direction="horizontal">
        <Form.Control style={{margin:"10px 0",width: onReload !== null? "469px":"600px"}} 
            onChange={onChanged}
            placeholder={placeholder}/>
            {onReload !== null && <Button
                onClick={onReload!}
                variant=""
                style={{
                    backgroundColor:"transparent",
                    padding: "5px 5px",
                    color:"#565656"}
                }>
                <ReloadIcon /> 
            </Button>   
            } 
        </Stack>
    )
}

export default Searchbar